module.exports = __webpack_public_path__ + "img/11.4fe26171.png";